import { api } from '../../api/client'

// Dotahování chybějících dat přes POST fill endpointy (viz doc/plans/to-fill-data-fetching.md).
//
// item.endpoint je "/api/daily_ts/fill"; api.post prefixuje BASE_URL (/api) → strip prefixu.
const stripApi = (ep) => ep.replace(/^\/api(?=\/)/, '')

// Zpracuje to_fill STRIKTNĚ SÉRIOVĚ — `for` s `await` uvnitř, další POST se pošle
// až po dokončení předchozího. NIKDY Promise.all / paralelně (nezahltit server).
//   onProgress(done, total)      — po každé položce (i neúspěšné)
//   onFilled(resp, item)         — jen když server reálně něco dotáhl (resp.filled === true,
//                                  a není abort) — signál pro cache-bust grafu. `filled:false`
//                                  + `up_to_date` znamená „data jsou aktuální" a NESMÍ se to
//                                  brát jako „dotaženo" (jinak nekonečný cache-bust grafu).
//   onSettled(item, resp, filled) — po každé zpracované položce (i benigní skip / chyba, ne abort).
//                                  resp.data = aktuální stav té jedné řady z DB — chodí i při
//                                  filled:false, tabulka ji mergne místo refetche celé query.
//                                  resp = null při chybě. `filled` = resp.filled === true.
//   signal (AbortSignal, volit.) — přeruší smyčku mezi položkami
// Vrací souhrn { done, total, filledCount }.
export async function runToFill(toFill, { onProgress, onFilled, onSettled, signal } = {}) {
  const items = toFill ?? []
  let filledCount = 0
  for (let i = 0; i < items.length; i++) {
    if (signal?.aborted) break
    const item = items[i]
    let resp = null
    let filled = false
    try {
      resp = await api.post(stripApi(item.endpoint), item.params)
      // „Dotaženo" = server reálně upsertoval řádky / posunul observation_available.
      // resp.data (kompletní řada) chodí i při filled:false (up_to_date) — to NENÍ dotažení.
      if (!signal?.aborted && resp?.filled === true && Array.isArray(resp?.data)) {
        filled = true
        filledCount++
        onFilled?.(resp, item)
      }
    } catch (e) {
      // 403 (online_none / access_denied) apod. — benigní, jen debug log
      if (import.meta.env.DEV) {
        console.debug('[toFill] přeskočeno', item.endpoint, e?.status, e?.message)
      }
    }
    if (!signal?.aborted) onSettled?.(item, resp, filled)
    onProgress?.(i + 1, items.length)
  }
  return { done: items.length, total: items.length, filledCount }
}
